import i18n from '@i18next/i18n';
import { ActionService } from '.';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import type { ILogger } from '../../../slide-data-services.core';
import type { ILocalToOnlineProvider } from './local-to-online-main-action-service';

export class LocalToOnlineMinorActionService extends ActionService {
    protected loggerPrefix = '[LocalToOnlineMinorActionService]';

    public constructor(protected logger: ILogger, protected tipsProvider: ILocalToOnlineProvider) {
        super(logger);
    }

    public async handleCommitSuccess(commitTotal: number, lastCommitLength: number): Promise<void> {
        this.logger.log(this.loggerPrefix, 'receive new commit');

        this.tipsProvider.showTips({ message: i18n.t(`上传进度${Math.floor((commitTotal - lastCommitLength) / commitTotal * 100)}%`), closable: true });

        OnlineEditServices.CollaborationManager()?.getSocket()
            .reConnect();
    }

    public async handleCommitComplete(): Promise<void> {
        this.tipsProvider.hideTips();
    }
}
